import { C } from '../../../../lib/design';
import { Ic, ICON_PATHS } from '../../../../lib/ui';
import { useI18n } from '../../../../i18n';
import { DOC_COLORS } from '../../../../config/documentStyles';
import { InfoTooltip } from '@/components/ui/InfoTooltip';

interface ProcessSheetHeaderProps {
  fichaCode: string;
  procesoCodigo: string;
  procesoNombre: string;
  fcDocEstado: string | null;
  zoom: number;
  setZoom: (fn: (z: number) => number) => void;
  showAi: boolean;
  setShowAi: (v: boolean) => void;
  editMode: boolean;
  setEditMode: (fn: (v: boolean) => boolean) => void;
}

export function ProcessSheetHeader({
  fichaCode,
  procesoCodigo,
  procesoNombre,
  fcDocEstado,
  zoom,
  setZoom,
  showAi,
  setShowAi,
  editMode,
  setEditMode,
}: ProcessSheetHeaderProps) {
  const { t } = useI18n();

  return (
    <header
      style={{
        height: 50,
        background: C.azul1,
        display: 'flex',
        alignItems: 'center',
        padding: '0 20px',
        gap: 0,
        flexShrink: 0,
        zIndex: 100,
      }}
    >
      <img
        src="/img/Logo-horizontal-Blanco.png"
        alt="Logo"
        style={{ height: 28, width: 'auto' }}
        onError={(e) => {
          (e.target as HTMLImageElement).style.display = 'none';
          const sib = (e.target as HTMLImageElement).nextElementSibling as HTMLElement;
          if (sib) sib.style.display = 'flex';
        }}
      />

      <div
        style={{ width: 1, height: 28, background: 'rgba(255,255,255,0.2)', margin: '0 16px' }}
      />

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <span
          style={{
            color: C.celeste,
            fontSize: 10,
            fontWeight: 600,
            letterSpacing: 1,
            textTransform: 'uppercase',
          }}
        >
          {fichaCode} &middot; Ficha de Caracterizacion
        </span>
        <span
          style={{
            color: 'white',
            fontSize: 14,
            fontWeight: 600,
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          {procesoCodigo} {procesoNombre}
          <InfoTooltip
            title={t.process.tooltips.ficha.titulo}
            text={t.process.tooltips.ficha.ayuda}
            position="bottom"
          />
        </span>
      </div>

      <div style={{ flex: 1 }} />

      <span
        style={{
          color: '#6EE7B7',
          background: 'rgba(22,163,74,0.2)',
          padding: '3px 10px',
          borderRadius: 20,
          fontSize: 11,
          fontWeight: 600,
          marginRight: 10,
        }}
      >
        VIGENTE
      </span>
      <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, marginRight: 10 }}>
        {fcDocEstado ?? '--'}
      </span>
      <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11, marginRight: 16 }}>
        {fichaCode}
      </span>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginRight: 12 }}>
        <button
          onClick={() => setZoom((z) => Math.max(30, z - 10))}
          style={{
            width: 26,
            height: 26,
            borderRadius: 4,
            border: '1px solid rgba(255,255,255,0.25)',
            background: 'transparent',
            color: 'white',
            cursor: 'pointer',
            fontSize: 14,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          -
        </button>
        <span
          style={{
            fontSize: 11,
            color: 'rgba(255,255,255,0.7)',
            minWidth: 36,
            textAlign: 'center',
            fontWeight: 600,
          }}
        >
          {zoom}%
        </span>
        <button
          onClick={() => setZoom((z) => Math.min(200, z + 10))}
          style={{
            width: 26,
            height: 26,
            borderRadius: 4,
            border: '1px solid rgba(255,255,255,0.25)',
            background: 'transparent',
            color: 'white',
            cursor: 'pointer',
            fontSize: 14,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          +
        </button>
      </div>

      <button
        onClick={() => setShowAi(!showAi)}
        style={{
          border: 'none',
          borderRadius: 6,
          padding: '6px 14px',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 600,
          color: 'white',
          marginRight: 6,
          background: showAi
            ? `linear-gradient(135deg, ${C.celeste}, ${DOC_COLORS.h3})`
            : 'rgba(255,255,255,0.15)',
          display: 'flex',
          alignItems: 'center',
          gap: 5,
        }}
      >
        <Ic d={ICON_PATHS.sparkle} s={14} c="white" /> IA
      </button>
      <button
        style={{
          border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: 6,
          padding: '6px 14px',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 600,
          color: 'white',
          background: 'transparent',
          marginRight: 6,
        }}
      >
        {t.process.exportarPdf}
      </button>
      <button
        onClick={() => setEditMode((v) => !v)}
        style={{
          border: 'none',
          borderRadius: 6,
          padding: '6px 14px',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 600,
          color: 'white',
          background: editMode
            ? `linear-gradient(135deg, #16A34A, #15803D)`
            : 'rgba(255,255,255,0.15)',
        }}
      >
        {editMode ? t.processSheet.editing : t.processSheet.edit}
      </button>
    </header>
  );
}
